import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const dashboardWallboardRoute: InvariantJiraRoute = {
	name: 'dashboard-wallboard',
	path: '/jira/dashboards/wallboard',
	query: ['dashboardId', 'cyclePeriod?', 'transitionFx?', 'random?'],
	exact: true,
};
